import { useEffect, useState } from "react";
import { Phone, MessageCircle, Menu, X } from "lucide-react";
import { buildWhatsAppUrl, trackEvent } from "@/lib/utm";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const wa = buildWhatsAppUrl(
    "5218116289267",
    "Hola Eclipse, me interesa cotizar FlexShade para mi espacio."
  );

  return (
    <>
      <header
        data-testid="navbar"
        className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
          scrolled
            ? "bg-black/95 backdrop-blur-md border-b border-white/10 py-2"
            : "bg-gradient-to-b from-black/60 to-transparent py-3"
        }`}
      >
        <div className="container-x flex items-center justify-between gap-4">
          <a href="#top" className="flex items-center gap-2.5" aria-label="Eclipse Cubiertas &middot; FlexShade">
            <img
              src="/images/logo_eclipse_oficial.png"
              alt="Eclipse"
              className="h-8 md:h-9 w-auto"
            />
            <span className="h-5 md:h-6 w-px bg-white/30" aria-hidden="true" />
            <img
              src="/brand/flexshade-logo.png"
              alt="FlexShade"
              className="h-5 md:h-6 w-auto"
            />
          </a>

          <nav className="hidden lg:flex items-center gap-7 text-white/85 text-sm font-medium">
            <a href="#modelos" className="hover:text-white">Modelos</a>
            <a href="#calculadora" className="hover:text-white" data-testid="nav-calc">Calculadora</a>
            <a href="#caracteristicas" className="hover:text-white">Características</a>
            <a href="#proyectos" className="hover:text-white">Proyectos</a>
            <a href="#faq" className="hover:text-white">FAQ</a>
          </nav>

          <div className="flex items-center gap-2">
            <a
              href="tel:+528189899822"
              className="hidden md:inline-flex items-center gap-2 text-white/90 text-sm font-semibold hover:text-white"
              onClick={() => trackEvent("phone_click", { location: "navbar" })}
              data-testid="navbar-call-btn"
            >
              <Phone className="w-4 h-4" /> Llámanos
            </a>
            <a
              href="#cotizar"
              data-testid="nav-cta"
              className="btn-primary px-4 py-2.5 rounded-lg text-sm hidden sm:inline-flex items-center gap-2"
            >
              Cotiza ahora
            </a>
            <button
              className="lg:hidden text-white p-2"
              onClick={() => setOpen((v) => !v)}
              aria-label="Menu"
            >
              {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {open && (
          <div className="lg:hidden bg-black border-t border-white/10">
            <div className="container-x py-4 flex flex-col gap-3 text-white/90 text-base">
              <a href="#modelos" onClick={() => setOpen(false)}>Modelos</a>
              <a href="#calculadora" onClick={() => setOpen(false)}>Calculadora</a>
              <a href="#caracteristicas" onClick={() => setOpen(false)}>Características</a>
              <a href="#proyectos" onClick={() => setOpen(false)}>Proyectos</a>
              <a href="#materiales" onClick={() => setOpen(false)}>Materiales</a>
              <a href="#faq" onClick={() => setOpen(false)}>FAQ</a>
              <div className="pt-2 flex gap-2">
                <a href={wa} target="_blank" rel="noreferrer" className="btn-wa flex-1 px-4 py-3 rounded-lg inline-flex items-center justify-center gap-2" onClick={() => trackEvent("whatsapp_click", { location: "navbar_mobile" })}>
                  <MessageCircle className="w-4 h-4" /> WhatsApp
                </a>
                <a href="tel:+528189899822" className="btn-outline-light flex-1 px-4 py-3 rounded-lg inline-flex items-center justify-center gap-2" onClick={() => trackEvent("phone_click", { location: "navbar_mobile" })}>
                  <Phone className="w-4 h-4" /> Llamar
                </a>
              </div>
            </div>
          </div>
        )}
      </header>
      <div id="top" />
    </>
  );
}
